import {WorkLocationList} from "./WorkLocationList";
import {WorkLocationEdit} from "./WorkLocationEdit";
import {WorkLocationCreate} from "./WorkLocationCreate";

export default {
    list: WorkLocationList,
};